export default "__VITE_ASSET__D1q6ZdOx__"